import api from './axios.v2.withoutTransform'

const userBankAccount = () => api('user/bankAccount', 'GET', {})
const userSubscriptions = () => api('user/subscriptions', 'GET', {})
const userPurchases = () => api('user/purchases', 'GET', {})
const editBankDetails = obj => api('user/bankAccount', 'POST', obj)

export default { userBankAccount, editBankDetails, userSubscriptions, userPurchases }
